var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ws-pt-checkbox",class:{
        'ws-pt-checkbox__active': _vm.checked || _vm.indeterminate,
        'ws-pt-checkbox__disabled': _vm.disabled,
    },attrs:{"data-check-status":_vm.checkboxIcon},on:{"click":_vm.onClick}},[_c('PzIcon',{attrs:{"icon":_vm.checkboxIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }